export function submissionId(): string {
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 15) | 64;
  bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export const evidenceFields = [
  ['FOTO_PADRAO_ENTRADA', 'Foto do padrão de entrada', 'Mostre o padrão inteiro. Prefira um enquadramento amplo, que permita identificar o local.'],
  ['FOTO_PADRAO_DISJUNTOR', 'Foto do padrão de entrada com disjuntor', 'Mostre o disjuntor e sua corrente nominal legível.'],
  ['FOTO_FACHADA_PADRAO', 'Foto da fachada com padrão de entrada', 'A fachada e o padrão devem aparecer na mesma foto.'],
  ['FOTO_QUADRO_INTERNO', 'Foto do quadro de disjuntores interno', 'Mostre o quadro e os disjuntores, quando existir.'],
  ['FOTO_LOCAL_INVERSOR', 'Foto do local de instalação do inversor', 'Use uma foto ampla. Prefira um local coberto e próximo ao padrão.'],
  ['VIDEO_QUADRO_INVERSOR', 'Vídeo do quadro geral até o inversor', 'Grave caminhando por todo o percurso entre o quadro e o local do inversor.'],
  ['VIDEO_PADRAO_INVERSOR', 'Vídeo do padrão de entrada até o inversor', 'Grave outro vídeo, mostrando todo o percurso entre o padrão e o local do inversor.'],
  ['FOTO_TELHADO', 'Foto do telhado', 'Fotografe o telhado visto de baixo, sem subir nele.']
];

